// URL query parameter utilities for handling comma-separated array values
// Expected usage: parseArrayParam('a,b') => ['a','b'] and serializeArrayParam(['a','b']) => 'a,b'

/**
 * Parses a comma-separated URL parameter value into an array of strings
 * @param value - The URL parameter value (can be null, undefined, or a comma-separated string)
 * @returns An array of trimmed, non-empty strings
 */
export function parseArrayParam(value: string | null | undefined): string[] {
  if (!value) return [];
  // Split by comma, trim whitespace, and filter out empty strings
  return value
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);
}

/**
 * Serializes an array of strings into a comma-separated URL parameter value
 * @param values - The array of strings to serialize (can be null or undefined)
 * @returns A comma-separated string, or empty string if no values
 */
export function serializeArrayParam(values: string[] | null | undefined): string {
  if (!values || values.length === 0) return '';
  return values.join(',');
}

export default { parseArrayParam, serializeArrayParam };
